module.exports = __webpack_public_path__ + "static/favicon-2d537e45d49ece7eaa6aab7729dd1784.ico";